module.exports = __webpack_public_path__ + "img/verticalLift.8d704549.png";